export enum ContentEntityType {
    slide = 'slide',
    course = 'course',
    program = 'program',
}
